import GamesRoute from './routes/games';

import AppContainer from './app-container';
import {ReactRoute} from '../../utils/router-utils';

export default ReactRoute({
    path: '/app',
    auth: true,
    component: AppContainer,
    routes: [
        GamesRoute,
    ]
});





// WEBPACK FOOTER //
// ./src/js/routes/app/index.js